import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LicenseInfo } from "@mui/x-license";
import * as Sentry from "@sentry/react";

import EmbedForm from "./pages/EmbedForm";
import LandingPage from "./pages/LandingPage";
import Regulamin from "./pages/Regulamin";
import Polityka from "./pages/Polityka";

LicenseInfo.setLicenseKey(
  "6ad75d9b9f4ade1990209831c129f5aaTz0xMjkxMzYsRT0xODEwNzcxMTk5MDAwLFM9cHJlbWl1bSxMTT1hbm51YWwsUFY9aW5pdGlhbCxLVj0y",
);

Sentry.init({
  dsn: "https://4726a64c9f4fba2158a5cb9fd4b64408@sn.notaup.pl/5",
  environment: import.meta.env.VITE_ENV,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      unmask: [".sentry-unmask, [data-sentry-unmask]"],
    }),
  ],
  tracesSampleRate: 1.0,
  tracePropagationTargets: [
    /^https:\/\/beta.notaup\.pl\/api/,
    /^https:\/\/notaup\.pl\/api/,
    /^https:\/\/kontakt.notaup\.pl\/api/,
  ],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

function Home() {
  const urlParams = new URLSearchParams(window.location.search);
  const hasEmbedId = !!urlParams.get("id");
  return hasEmbedId ? <EmbedForm /> : <LandingPage />;
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/regulamin" element={<Regulamin />} />
        <Route path="/polityka-prywatnosci" element={<Polityka />} />
        <Route path="*" element={<Home />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
